import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import PlanSelector from "components/PlanSelector";
import Spacer from "components/Spacer";
import * as WebBrowser from "expo-web-browser";
import { setSelectedPlanPackage, setStep } from "features/slices/buyFlowSlice";
import { PlanPackageDetails } from "features/types";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import i18n from "plugins/localization";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import React from "react";
import { Pressable, View } from "react-native";
import { getPlanType } from "utils/planPackageUtils";

interface StepOneProps {
  onContinuePress: () => void;
}

const StepOne: React.FC<StepOneProps> = ({ onContinuePress }) => {
  const dispatch = useAppDispatch();
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();
  const { shouldCharge, planPackages, selectedPlanPackage } = useAppSelector(
    (state) => state.buyFlow
  );
  const isBankType = selectedPlanPackage
    ? getPlanType(selectedPlanPackage) === "BANK"
    : false;

  const openRedirectURL = () => {
    if (!tenantConfig) return;
    WebBrowser.openBrowserAsync(tenantConfig.buyflowRedirectUrl);
  };

  const determineNextStep = () => {
    // For voucher and bank products, if the total step is 2, then skip step 2, sign user up directly
    if (isBankType && !shouldCharge) {
      onContinuePress();
      return;
    }
    dispatch(setStep(isBankType ? 3 : 2));
  };
  if (!planPackages || planPackages.length === 0) return null;

  return (
    <View>
      <View style={{ marginBottom: 15 }}>
        <Text category="h6">
          {i18n.t("screens.AccountSetup.purchaseYourMembership")}
        </Text>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 10,
          }}
        >
          <Text category="c1">For more information </Text>
          <Pressable onPress={openRedirectURL}>
            <Text category="c1" status="info">
              click here
            </Text>
          </Pressable>
        </View>
      </View>
      {planPackages.length === 1 ? (
        <Spacer>
          <Text category="h6">{planPackages[0].name}</Text>
        </Spacer>
      ) : (
        <PlanSelector
          planPackages={planPackages}
          selectedPlanPackage={selectedPlanPackage}
          onChange={(planPackage: PlanPackageDetails) => {
            dispatch(setSelectedPlanPackage(planPackage));
          }}
        ></PlanSelector>
      )}
      <Button style={{ marginTop: 25 }} onPress={determineNextStep}>
        {i18n.t("common.continue")}
      </Button>
    </View>
  );
};

export default StepOne;
